import PanelGlucometria from './PanelGlucometria';
import PanelEspirometria from './PanelEspirometria';
import PanelLipidograma from './PanelLipidograma';
import PanelPerimetroAbdominal from './PanelPerimetroAbdominal';

// Cada módulo registra aquí su panel.
// Un módulo sin panel registrado muestra ModuloPlaceholder.
// Props que recibe todo panel: { modulo, numeroDocumento, evbi, onRegistrado }.
export const PANELES_MODULO = {
	glucometria: PanelGlucometria,
	espirometria: PanelEspirometria,
	lipidograma: PanelLipidograma,
	perimetroAbdominal: PanelPerimetroAbdominal,
};
